import React from 'react';
import '../css/Portfolio.css';
import gladosScreenshot from '../image/Glados.png';
import f1DashScreenshot from '../image/f1dash.png';

const publicPortfolio = [
  {
    title: 'Personal website',
    description:
      'Designed, developed, and currently maintain this portfolio website ensuring responsive design, optimized performance, and seamless updates.',
  },
  {
    title: 'GlaDOS',
    description:
      'A self-hosted, voice-driven personal assistant with a GLaDOS-inspired personality; listens, reads emotion, thinks with a local LLM, and talks back.',
    link: 'https://github.com/Beremas/GlaDOS_v1_0',
    image: gladosScreenshot,
    imageAlt: 'GlaDOS voice assistant showing its system information panel and a spoken response',
    facts: [
      { label: 'Problem', text: 'Wanted hands-free access to an LLM at home without depending on a third-party voice assistant or cloud service.' },
      { label: 'Approach', text: 'Stitched together speech-to-text (Vosk), emotion recognition (ONNX), a local LLM (Llama 2 7B), and voice synthesis into one pipeline, wrapped in a GLaDOS-styled personality.' },
      { label: 'Result', text: 'A fully offline voice assistant that listens, reasons, and replies in character; published open source.' },
    ],
  },
  {
    title: 'F1 Historical Data Dashboard',
    description:
      'An interactive dashboard for exploring race weekends; lap times, pit strategy, and circuit maps in one view.',
    link: 'https://github.com/Beremas/OpenF1Dashboard',
    image: f1DashScreenshot,
    imageAlt: 'OpenF1 Analyzer dashboard showing a circuit map, lap time chart, and pit stop timeline',
    facts: [
      { label: 'Problem', text: 'Race weekend data; lap times, pit strategy, tyre stints, results; is scattered across sources and hard to compare at a glance.' },
      { label: 'Approach', text: 'Built a dashboard on the OpenF1 API pulling lap-by-lap timing, pit stop history, and circuit GeoJSON into a single filterable view.' },
      { label: 'Result', text: 'One page to compare any driver’s pace, strategy, and result for a given circuit and season.' },
    ],
  },
];

const privatePortfolio = [
  {
    title: 'Friend’s website maintenance',
    description:
      'Ongoing technical support and feature updates for a friend’s private sites, managing both backend reliability and frontend usability improvements.',
    sites: ['Ecommerce site', 'Portfolio site'],
  },
  {
    title: '.NET Human-Machine Parser',
    description:
      'Developed a custom C# parser that bridges the gap between human-readable instructions and machine-executable logic. This tool allows operational and client teams to define complex rules in a simple, intuitive format, which the system can interpret and execute automatically. The project emphasizes clarity, usability, and reliability, enabling non-technical users to interact with sophisticated software processes without needing programming expertise.',
    note: 'Built for current company usage',
  },
];

const ProjectCard = ({ item }) => (
  <article className="card">
    {item.image && (
      <div className="card-media">
        <img src={item.image} alt={item.imageAlt || ''} loading="lazy" />
      </div>
    )}
    <div className="card-head">
      <h2 className="card-title">{item.title}</h2>
      {item.note && <span className="card-tag">{item.note}</span>}
    </div>
    <p className="card-body">{item.description}</p>
    {item.facts && (
      <dl className="card-facts">
        {item.facts.map(({ label, text }) => (
          <div className="card-fact" key={label}>
            <dt className="card-fact-label">{label}</dt>
            <dd className="card-fact-text">{text}</dd>
          </div>
        ))}
      </dl>
    )}
    {item.sites && (
      <ul className="card-sublist">
        {item.sites.map((site) => (
          <li key={site}>{site}</li>
        ))}
      </ul>
    )}
    {item.link && (
      <a
        href={item.link}
        target="_blank"
        rel="noopener noreferrer"
        className="card-link"
      >
        <i className="fa-brands fa-github" aria-hidden="true"></i>
        View on GitHub
      </a>
    )}
  </article>
);

const Portfolio = () => {
  return (
    <section className="portfolio">
      <header className="section-head">
        <span className="section-eyebrow">
          {publicPortfolio.length + privatePortfolio.length} projects
        </span>
        <h1 className="section-title">Portfolio</h1>
      </header>

      <h2 className="portfolio-group-label">Public</h2>
      <div className="card-stack">
        {publicPortfolio.map((item, index) => (
          <ProjectCard key={index} item={item} />
        ))}
      </div>

      <h2 className="portfolio-group-label">Private</h2>
      <div className="card-stack">
        {privatePortfolio.map((item, index) => (
          <ProjectCard key={index} item={item} />
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
